export const itemRouter = {
    name: 'item-main',
    component: () => import(/* webpackChunkName: "itemMain" */ '@/modules/item/pages/MainPage'),
    children: [
        {
            path: '',
            name: 'item',
            component: () => import(/* webpackChunkName: "item" */ '@/modules/item/pages/ItemPage'),
            props: (route) => {
                const table_id = Number(route.query.table_id)
                return isNaN(table_id) ? {table_id: 0} : {table_id: table_id}
            },
        },
        {
            path: ':id',
            name: 'item-detail',
            component: () => import(/* webpackChunkName: "itemPage" */'@/modules/item/pages/ItemDetailPage'),
            props: (route) => {
                const id = Number(route.params.id)
                return isNaN(id) ? {it_id: 0} : {it_id: id}
            },
        }
    ],
}
